import { render } from "./ListPersonGroup.vue?vue&type=template&id=b318adae"
import script from "./ListPersonGroup.vue?vue&type=script&lang=js"
export * from "./ListPersonGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__